import { useCallback, useState } from 'react';

import { useNodeGrants, useSetNodeGrants } from '~services/api/hooks/content-access.hooks';
import { PermissionsTableContainer } from './PermissionsTableContainer';

export type ManagePermissionsProps = {
  nodeId: string;
  title: string;
};

export const ManagePermissions = ({ nodeId, title }: ManagePermissionsProps) => {
  const [isUpdateSuccessful, setIsUpdateSuccessful] = useState<boolean>(undefined);

  // Define: state update for notifing user about successful update
  const updateSuccess = useCallback((success: boolean) => {
    setIsUpdateSuccessful(success);
    setTimeout(() => {
      setIsUpdateSuccessful(undefined);
    }, 5000);
  }, []);

  // Define: get permissions query
  const { data, isLoading } = useNodeGrants(nodeId);

  // Define: update permissions query
  const { mutate: updateGrants, isPending: isUpdating } = useSetNodeGrants({
    onSuccess: success => {
      updateSuccess(success);
    },
    onError: () => {
      updateSuccess(false);
    },
  });

  // Handler: update permissions
  const handleUpdate = useCallback(
    (update: UpdateMenuLinkGrantsDto) => {
      updateGrants({ nodeId: nodeId, grants: update });
    },
    [updateGrants, nodeId],
  );

  return (
    <PermissionsTableContainer
      menuLinkGrants={data}
      isLoading={isLoading}
      isUpdating={isUpdating}
      isProcessing={isUpdating}
      onUpdate={handleUpdate}
      nodeName={title}
      updateSuccess={isUpdateSuccessful}
    />
  );
};
